var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "passcode"
  }, [_vm.showContent ? [_c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.validatePasscode.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "passcode-copy"
  }, [_vm._v("\n        " + _vm._s(_vm.translations.passcodeDescr) + "\n      ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.passcode,
      expression: "passcode"
    }],
    ref: "passcodeInput",
    class: ['passcode-input', {
      'passcode-input--error': _vm.hasError
    }],
    attrs: {
      "type": "password",
      "name": "passcode",
      "disabled": _vm.disablePasscodeInput
    },
    domProps: {
      "value": _vm.passcode
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
      },
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.passcode = $event.target.value;
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.hasError,
      expression: "hasError"
    }],
    staticClass: "passcode-error-message"
  }, [_vm.isCampaignInvalid || _vm.isCampaignExpired ? _c('div', {
    staticClass: "passcode-error-message-campaign-expired"
  }, [_vm._v(_vm._s(_vm.translations.passcodeWCampExpired))]) : _vm.isPasscodeInvalid ? _c('div', {
    staticClass: "passcode-error-message-invalid-passcode"
  }, [_vm._v(_vm._s(_vm.translations.passcodeWPassInvalid))]) : _vm._e()]), _c('button', {
    class: ['button', 'passcode-cta-button', _vm.isValidatingPasscode ? 'passcode-cta-button--disabled' : 'primary'],
    attrs: {
      "type": "submit",
      "disabled": _vm.disableContinueButton
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isValidatingPasscode,
      expression: "!isValidatingPasscode"
    }]
  }, [_c('span', {
    staticClass: "passcode-cta-button-label-text"
  }, [_vm._v("\n            " + _vm._s(_vm.translations.passcodeContinue) + "\n          ")]), _c('span', {
    staticClass: "icon icon-arrow-right-indicator-open passcode-cta-button-icon"
  })]), _c('base-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isValidatingPasscode,
      expression: "isValidatingPasscode"
    }],
    staticClass: "passcode-cta-button-spinner",
    attrs: {
      "size": "16",
      "position": "inherit"
    }
  })], 1)]), _c('div', {
    staticClass: "passcode-go-to-customs-home-link"
  }, [_c('a', {
    attrs: {
      "href": _vm.customsHomeUrl
    }
  }, [_vm._v("\n        " + _vm._s(_vm.translations.passcodeUrl) + "\n        "), _c('span', {
    staticClass: "passcode-go-to-customs-home-link-url"
  }, [_vm._v("\n            " + _vm._s(_vm.displayableCustomsHomeUrl) + "\n          ")])])])] : [_c('base-spinner', {
    attrs: {
      "position": "inherit"
    }
  })]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }